import React from 'react';
import './AgendaGestaoSection.css';

const AgendaGestaoSection = () => {
  return (
    <section className="agenda-gestao-section">
      <div className="agenda-gestao-content">
        <div className="agenda-gestao-header">
          <h2 className="agenda-gestao-title">
            Agenda cheia e gestão simples.
          </h2>
          <p className="agenda-gestao-subtitle">
            Validação via QR Code, relatórios básicos de uso e controle de agenda em tempo real — sem precisar trocar seu sistema atual.
          </p>
        </div>
        
        <div className="agenda-gestao-cards">
          <div className="agenda-gestao-card">
            <h3 className="agenda-card-title">Leitura de QR Code</h3>
            <p className="agenda-card-description">
              Valide agendamentos rapidamente com leitura de QR Code no atendimento.
            </p>
          </div>
          
          <div className="agenda-gestao-card">
            <h3 className="agenda-card-title">Pagamento fácil</h3>
            <p className="agenda-card-description">
              Receba pagamentos de forma simples e automática, sem complicações.
            </p>
          </div>
          
          <div className="agenda-gestao-card">
            <h3 className="agenda-card-title">Gestão completa</h3>
            <p className="agenda-card-description">
              Controle sua agenda, relatórios e clientes tudo em um só lugar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgendaGestaoSection;

